import { makeStyles, Theme } from '@material-ui/core/styles';
import { blackHaze, gainsboro, orangered } from 'styles/abstract/variables';

export const makeProductsSetStyles = makeStyles((theme: Theme) => ({
    priceField: {
        margin: theme.spacing(0, 2),
    },
    sectionTitle: {
        marginBottom: theme.spacing(1),
    },
    summary: {
        alignItems: 'center',
        backgroundColor: blackHaze,
        border: `0.0625rem solid ${gainsboro}`,
        display: 'flex',
        justifyContent: 'flex-end',
        marginBottom: theme.spacing(2),
        padding: theme.spacing(2, 1),
        width: '100%',

        '& b': {
            color: orangered,
            fontSize: '1.125rem',
            marginLeft: theme.spacing(1),
        },
    },
    tableHeader: {
        display: 'flex',
        marginBottom: theme.spacing(1),
    },
    tableHeaderItem: {
        backgroundColor: blackHaze,
        border: `0.0625rem solid ${gainsboro}`,
        padding: theme.spacing(1),

        '&:first-child': {
            marginRight: theme.spacing(0.5),
        },

        '&:last-child': {
            marginLeft: theme.spacing(0.5),
        },
    },
    tableRow: {
        alignItems: 'center',
        display: 'flex',
        marginBottom: theme.spacing(0.5),

        '& > div': {
            alignItems: 'center',
            alignSelf: 'stretch',
            border: `0.0625rem solid ${gainsboro}`,
            display: 'flex',
            padding: '8px',
        },

        '& > div:first-of-type': {
            marginRight: theme.spacing(0.5),
        },

        '& > div:last-child': {
            marginLeft: theme.spacing(0.5),
        },
    },
}));
